import React from 'react';
import { Mic, Square } from 'lucide-react';
import { useVoiceDetection } from '../hooks/useVoiceDetection';

interface AudioRecorderProps {
  isListening: boolean;
  onMicClick: () => void;
}

export const AudioRecorder: React.FC<AudioRecorderProps> = ({ isListening, onMicClick }) => {
  return (
    <button
      type="button"
      onClick={onMicClick}
      className={`p-3 rounded-full transition-colors ${
        isListening 
          ? 'bg-red-500 text-white hover:bg-red-600' 
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      }`}
    >
      {isListening ? <Square className="w-5 h-5" /> : <Mic className="w-5 h-5" />}
    </button>
  );
};